import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { Button, Dropdown, Icons } from '@commenda/kakashi';

const ProductTabEmptyState = ({
  onAddProduct,
  onImportProducts,
  onConnectIntegration,
  onDownloadTemplate,
}: {
  onAddProduct: () => void;
  onImportProducts: () => void;
  onConnectIntegration: () => void;
  onDownloadTemplate: () => void;
}) => {
  const isRootfiIntegrationEnabled = isFeatureLaunched(
    FeatureLaunch.SALES_TAX_ROOTFI_INTEGRATION
  );

  return (
    <main className="flex flex-col min-h-[calc(100vh-401px)]">
      <div className="flex flex-col w-[640px] m-auto justify-center">
        <div className="flex items-start mt-5 flex-col gap-2">
          <h1 className="display-xs-bold">
            Add products to begin tracking sales tax
          </h1>
          <p className="txt-small-regular text-text-secondary">
            Upload your product catalog to categorize items with tax codes for
            compliance.
          </p>
        </div>

        {isRootfiIntegrationEnabled ? (
          <div className="w-full flex items-center mt-8 gap-3">
            <Button onClick={onConnectIntegration} size="md">
              <Icons.Link03 className="size-4" />
              <span>Connect integration</span>
            </Button>

            <Dropdown
              align="end"
              menu={{
                groups: [
                  {
                    items: [
                      {
                        icon: Icons.Upload01,
                        label: 'Import products',
                        onClick: onImportProducts,
                      },
                    ],
                  },
                ],
              }}
            >
              <Button variant="secondary" size="md">
                <Icons.Plus className="size-4" />
                <span>Add product</span>
              </Button>
            </Dropdown>
          </div>
        ) : (
          <div className="w-full flex items-center mt-8 gap-3 justify-center">
            <Button onClick={onImportProducts} size="md">
              <Icons.Download01 className="size-4" />
              <span>Import products</span>
            </Button>

            <Button variant="secondary" onClick={onAddProduct} size="md">
              <Icons.Plus className="size-4" />
              <span>Add Manually</span>
            </Button>
          </div>
        )}
      </div>
    </main>
  );
};

export default ProductTabEmptyState;
